import { render, staticRenderFns } from "./GalleryListItemLayout.vue?vue&type=template&id=2f1f93ac&scoped=true"
import script from "./GalleryListItemLayout.vue?vue&type=script&lang=js"
export * from "./GalleryListItemLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f93ac",
  null
  
)

export default component.exports